var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgEmailWhite = _ref => {
  let {
    svgRef,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Email",
    width: 25.593,
    height: 18.281,
    viewBox: "0 0 25.593 18.281",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_777",
    "data-name": "Path 777",
    d: "M24.851,6H4.742A2.742,2.742,0,0,0,2,8.742v12.8a2.742,2.742,0,0,0,2.742,2.742H24.851a2.742,2.742,0,0,0,2.742-2.742V8.742A2.742,2.742,0,0,0,24.851,6Zm-6.027,8.924,6.941-3.737v8.592ZM4.742,7.828H24.851a.914.914,0,0,1,.914.914v.366L14.8,15.016,3.828,9.108V8.742A.914.914,0,0,1,4.742,7.828Zm-.914,3.358,6.941,3.737L3.828,19.783ZM24.851,22.452H4.742a.908.908,0,0,1-.81-.511l8.639-6.047,1.792.964a.914.914,0,0,0,.866,0l1.792-.965,8.639,6.047a.908.908,0,0,1-.811.512Z",
    transform: "translate(-2 -6)",
    fill: "#FFFFFF"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmailWhite, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/email_white.f3c3f99b.svg";
export { ForwardRef as ReactComponent };